import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { formatCurrencyValue } from '@vend/utilities'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../ng-compat/hooks'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleFinals } from '../../../state/slices/currentSale/currentSaleSlice'

export const SaleTax: FunctionComponent = () => {
  const { tax, taxes, taxDisplayProperties } = useAppSelector(selectSaleFinals)
  const retailer = useRetailerSettingsManager().get()
  const registerManager = useRegisterManager()
  const currentOutlet = registerManager.getActiveOutlet()
  const { taxName } = taxDisplayProperties
  const taxCount = Object.keys(taxes).length

  return (
    <>
      <li className="sale-summary-line sale-summary-line--tax vd-pt2">
        <div className="sale-summary-line-item sale-summary-line-item--label">
          {taxCount > 1 ? (
            <T
              _str="{taxCount, plural, one {Tax ({taxCount} tax)} other {Tax {taxCount} Taxes}}"
              _context="Tax label in sale summary"
              taxCount={taxCount}
            />
          ) : (
            <T
              _str="Tax {taxName}"
              _context="Tax label in sale summary"
              taxName={taxName}
            />
          )}
        </div>
        <div className="sale-summary-line-item sale-summary-line-item--value">
          {formatCurrencyValue(
            tax,
            retailer.culture,
            currentOutlet.currency,
            currentOutlet.currency_symbol
          )}
        </div>
      </li>

      {Object.keys(taxes).length > 1 &&
        Object.entries(taxes).map(([id, tax]) => (
          <li
            key={id}
            className="sale-summary-line sale-summary-line--tax-breakdown"
          >
            <div className="sale-summary-line-item sale-summary-line-item--label">
              {tax.name}
            </div>
            <div className="sale-summary-line-item sale-summary-line-item--value">
              {formatCurrencyValue(
                tax.total,
                retailer.culture,
                currentOutlet.currency,
                currentOutlet.currency_symbol
              )}
            </div>
          </li>
        ))}
    </>
  )
}
